import appApi from "@/api/appApi";
import { API_ENDPOINT } from "@/setup/constants";
import showProfile from "@/services/common/showProfile";

export default {
  login() {
    return new Promise((resolve, reject) => {
      const popup = window.open(
        `${API_ENDPOINT}/auth`,
        "",
        "top=100,left=100,width=900,height=600"
      );

      const popupChecker = setInterval(() => {
        if (popup.closed) {
          clear();
          reject("closed");
        }
        popup.postMessage("auth_token", "*");
      }, 1000);

      window.addEventListener("message", onMessage);

      function onMessage(e) {
        if (e.data.message && e.data.message === "auth_token") {
          clear();
          popup.close();
          resolve(e.data.token);
        }
      }

      function clear() {
        clearTimeout(popupChecker);
        window.removeEventListener("message", onMessage);
      }
    });
  },

  getProfile() {
    return appApi.get("/site/profile").then(response => response.data);
  },

  register(formData) {
    return appApi.post("/site/registration", formData).then(({ data }) => data);
  },

  checkIsNewbie() {
    return appApi.get("/site/is-newbie").then(({ data }) => !!data.success);
  },

  checkIsReferee() {
    return appApi.get("/site/is-referee").then(({ data }) => !!data.success);
  },

  showProfile
};
